import Trix from 'trix'

// Add support for h2 and h3 headings
Trix.config.blockAttributes.heading2 = {
  tagName: 'h2',
  terminal: true,
  breakOnReturn: true,
  group: false
}

Trix.config.blockAttributes.heading3 = {
  tagName: 'h3',
  terminal: true,
  breakOnReturn: true,
  group: false
}

// Add support for inline code
Trix.config.textAttributes.inlineCode = {
  tagName: 'code',
  inheritable: false
}
